import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { Card, CardContent } from '@/components/ui/card';
import { Loader2, Clock, User } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Categories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${API}/categories`);
      setCategories(response.data);
    } catch (error) {
      console.error('Error fetching categories:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      {/* Hero */}
      <section className="bg-gradient-to-r from-red-600 to-red-800 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl font-bold mb-4" data-testid="categories-title">Categorias e Times</h1>
          <p className="text-xl">
            Formação esportiva completa para todas as idades
          </p>
        </div>
      </section>

      {/* Categories Grid */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {loading ? (
            <div className="flex justify-center items-center py-20">
              <Loader2 className="animate-spin h-12 w-12 text-red-600" />
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {categories.map((category) => (
                <Card key={category.id} className="hover:shadow-xl transition" data-testid={`category-card-${category.id}`}>
                  <CardContent className="p-6">
                    <div className="mb-4">
                      <h2 className="text-3xl font-bold text-gray-900 mb-2">{category.name}</h2>
                      <p className="text-red-600 font-semibold text-lg">{category.age_range}</p>
                    </div>
                    
                    <p className="text-gray-700 mb-6 leading-relaxed">{category.description}</p>
                    
                    <div className="space-y-3 mb-6">
                      <div className="flex items-start text-gray-600">
                        <Clock className="mr-2 text-red-600 mt-1 flex-shrink-0" size={20} />
                        <div>
                          <p className="font-semibold">Horários:</p>
                          <p className="text-sm">{category.schedule}</p>
                        </div>
                      </div>
                      {category.coach_name && (
                        <div className="flex items-center text-gray-600">
                          <User className="mr-2 text-red-600" size={20} />
                          <div>
                            <p className="font-semibold">Treinador:</p>
                            <p className="text-sm">{category.coach_name}</p>
                          </div>
                        </div>
                      )}
                    </div>
                    
                    <Link to="/enrollment">
                      <Button className="w-full bg-red-600 hover:bg-red-700" data-testid={`enroll-category-${category.id}`}>
                        Inscrever Nesta Categoria
                      </Button>
                    </Link>
                  </CardContent>
                </Card>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Não sabe qual categoria escolher?
          </h2>
          <p className="text-xl text-gray-600 mb-8">
            Entre em contato conosco e nossa equipe ajudará a encontrar a categoria ideal para seu filho.
          </p>
          <a href="https://api.whatsapp.com/send?phone=5511950200214" target="_blank" rel="noopener noreferrer">
            <Button size="lg" className="bg-green-600 hover:bg-green-700 text-lg px-8 py-6">
              Falar no WhatsApp
            </Button>
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Categories;